import { useActorStore } from '@/stores/actor'
import { createAxiosAuthInstance, createXSRFInstance } from '@/config/auth'
import { useAuthStore } from '@/stores/auth'

export const useAuthDependencies = () => {
  const authStore = useAuthStore()
  const actorStore = useActorStore()
  return async () => {
    const { accessToken } = await authStore.checkToken()
    const currentActor = await actorStore.retrieveCurrentActor()
    const axios = createAxiosAuthInstance(accessToken, currentActor)(createXSRFInstance())
    return { axios }
  }
}
